// This snippet removes undesired filter options
document.addEventListener('DOMContentLoaded', function () {
  const select = document.getElementById('SortBySt');
  if (!select) return;

  const labelsToHide = ['Presenterad', 'Sortera förbi'];

  [...select.options].forEach(opt => {
    if (labelsToHide.includes(opt.text.trim())) {
      // If the option is selected, switch to a reasonable default
      if (opt.selected) {
        select.value = 'best-selling';
      }
      // ...and hide the element.
      opt.hidden = true;
    }
  });
});

// Rumspaket-sidorna: centrera ensamt sista paket i en rad (udda antal paket)
(function () {
  if (!/^\/([a-z]{2}\/)?pages\/(vardagsrum|matrum|kombinerat)\/?$/.test(location.pathname)) return;
  var s = document.createElement('style');
  s.textContent = '.collection-grid{justify-content:center}';
  (document.head || document.documentElement).appendChild(s);
})();

// Rumspaket-sidorna: storlekar.
// Sektionsrubriker (Baspaket, Pluspaket, Premiumpaket, Bygg ditt eget rum): dator 42 px, mobil 24 px, vikt 500.
// Paketnamn (Sanddyn, Vit Strand ...): två storlekar mindre. Dator 34 px, mobil 20 px, vikt 500.
(function () {
  if (!/^\/([a-z]{2}\/)?pages\/(vardagsrum|matrum|kombinerat)\/?$/.test(location.pathname)) return;
  var s = document.createElement('style');
  s.textContent = '@media (min-width:768px){.sec-ttl h2, .sec-ttl h2.h3{font-size:42px !important;font-weight:500 !important;line-height:1.2 !important}.collection-grid .ttlTxt{font-size:34px !important;font-weight:500 !important;line-height:1.2 !important}}' +
    '@media (max-width:767px){.sec-ttl h2, .sec-ttl h2.h3{font-size:24px !important;font-weight:500 !important;line-height:1.2 !important}.collection-grid .ttlTxt{font-size:20px !important;font-weight:500 !important;line-height:1.2 !important}}';
  (document.head || document.documentElement).appendChild(s);
})();

// Mobil: tryckytor minst 44 px (2026-11-03). Headerikonerna får ett osynligt förstorat tryckområde (::after) så att layouten inte ändras.
(function () {
  var s = document.createElement('style');
  s.textContent = '@media (max-width:767px){' +
    '.hdicon{position:relative}' +
    '.hdicon::after{content:"";position:absolute;left:-4px;right:-4px;top:-12px;bottom:-12px}' +
    '.flickity-button{width:44px!important;height:44px!important}' +
    '.btn.btn-options,.btn.quick-view{min-width:44px;min-height:44px;display:inline-flex;align-items:center;justify-content:center}' +
    '.grid-view-item__title{display:inline-block;padding:12px 0}' +
    '.btn.mob-btn-md{min-height:48px}' +
    '.btn-link.closeSearch{min-width:44px;min-height:44px}' +
    '.search__submit{min-width:44px;min-height:44px}' +
    'footer a[href^="mailto:"]{display:inline-block;padding:12px 0}}';
  (document.head || document.documentElement).appendChild(s);
})();